import React, { useState, useEffect, useRef } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Instagram,
  Linkedin,
  Youtube,
} from "lucide-react";
import "./Homepage.css";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  motion,
  useAnimation,
  AnimatePresence,
  useScroll,
  useTransform,
} from "framer-motion";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PartnerImage from "../assets/images/main.png";
import landingImage from "../assets/images/ai.png";
import Footer from "./Footer";
import IndustriesSection from "./IndustriesSection";
import IntegrationFlow from "./IntegrationFlow";
import Header from "./Header";
const isMac = /Mac/.test(navigator.platform);

const servicesData = [
  {
    id: 1,
    number: "01",
    title: (
      <>
        {window.innerWidth >= 768 ? (
          <>
            Integration
            <br />
            solutions
          </>
        ) : (
          <>Integration solutions</>
        )}
      </>
    ),
    description:
      "Break free from legacy limits—seamless, scalable, and future-proof migrations with zero disruption! Empower your business with next-gen connectivity and automation. ",
    color: "#F8A007",
  },
  {
    id: 2,
    number: "02",
    title: (
      <>
        Enterprise <br /> Solutions{" "}
      </>
    ),
    description:
      "Seamless connectivity to streamline your business operations. Integrate faster, scale effortlessly, and stay ahead of the competition.",
    color: "#6B6DEC",
  },
  {
    id: 3,
    number: "03",
    title: (
      <>
        Cloud-Native <br /> Excellence
        <span
          style={{ display: "block", fontSize: "40px", margin: 0, padding: 0 }}
        >
          {" "}
        </span>
      </>
    ),
    description:
      "Accelerate software delivery with DevOps automation, CI/CD pipelines, and cloud-native scalability. Boost efficiency, reduce downtime, and innovate faster.",
    color: "#EC6B89",
  },
  {
    id: 4,
    number: "04",
    title: (
      <>
        {window.innerWidth >= 768 ? (
          <>
            Application
            <br /> Support{" "}
          </>
        ) : (
          <>Application Support</>
        )}
      </>
    ),
    description:
      "Ensure seamless performance, rapid issue resolution, and optimized system efficiency. Maximize uptime and keep your applications running at peak performance.",
    color: "#30D8C5",
  },
  // { id: 5, number: '05', title: <>ERP Consulting & End-to-End Solutions </>, description: 'Optimize, Integrate, and Scale with a Future-Ready ERP System .', color: '#30D8C5' },
];

const slides = [
  {
    id: 1,
    text: "“CyntraLabs ensured a seamless Azure migration, reducing costs and optimizing integration efficiency.”",
    position: "Talking Rain Beverage Company",
    author: "Dave Horner ",
    position: "Vice President",

    img: "/images/nwww.png",
    bgColor: "#FFDDC1", // Light Orange
  },
  {
    id: 2,
    text: "“CyntraLabs optimized eligibility verification with Dell Boomi, improving speed, accuracy, and scalability”",
    position: "DHS Georgia",
    author: "Mohan S.",
    position: "Assistant Commissioner",
    // author: "Mohan S. (Assistant Comissioner)",
    img: "/images/georgiadhs_logo.jpeg",
    bgColor: "#FFDDC1",
  },
  {
    id: 3,
    text: "“The SAP to Epicor migration using Azure Logic Apps was seamless, efficient, and exceeded our expectations.”",
    author: "Jim Wilkins",
    position: "Head of Boppy NA",
    img: "/images/freepik__background__54022.png",
    bgColor: "#C1E1FF", // Light Blue
  },
  {
    id: 4,
    text: "“CyntraLabs unified data with Segment CDP, enhancing engagement, targeting, and revenue growth.”",
    author: "Ricardo Gonzalez",
    position: " Director",

    img: "/images/mark_Antony.png",
    bgColor: "#FFDDC1", // Light Orange
  },

  {
    id: 5,
    text: "“Thrilled with the project's progress! Sparking excitement as they prioritize AI initiatives across the project.”",
    author: "Greg Jensen",
    position: "Program Manager",
    img: "/images/freepik__background__31517.png",
    bgColor: "#FFDDC1",
  },

  // {
  //   id: 6,
  //   text: "“With SAP ECC and custom integrations, we provided strategic consulting, precise tool selection, and seamless API-driven development”",
  //   author: "Watches of Switzerland",
  //   position: "Seamless Migration to D365",
  //   img: "/images/wos-logo1.png",
  //   bgColor: "#C1E1FF", // Light Blue
  // },
  {
    id: 7,
    text: "“The SAP S/4 & EDI solution with SAP PI/PO 7.5 enabled seamless integration, rapid deployment, and enhanced efficiency for our customers.”",
    author: "Krishna Kashyap",
    position: "Vice President",
    img: "/images/Shiseido-logo.png",
    bgColor: "#D1FFC1", // Light Green
  },
  {
    id: 8,
    text: "“CyntraLabs' API-first approach enabled a smooth MuleSoft migration, enhancing global integration and efficiency.”",
    author: "Ricardo Gonzalez",
    position: "Director",

    img: "/images/mark_Antony.png",
    bgColor: "#C1E1FF", // Light Blue
  },

  {
    id: 9,
    text: "“With MuleSoft on-premise integration for SAP S/4 & financial systems, we achieved seamless connectivity & rapid deployment using factory model approach”",
    author: "Dmitriy Gerzon",
    position: "Director",
    img: "/images/QVC-Logo.png",
    bgColor: "#D1FFC1", // Light Green
  },
  {
    id: 10,
    text: "“With SAP Ariba, SAP CPI, and MuleSoft, we delivered a strategic, end-to-end integration solution, ensuring seamless API and web services connectivity.”",
    author: "Michael Kepe",
    position: "Vice-President",
    img: "/images/ContractPodAI-Logo.png",
    bgColor: "#D1FFC1", // Light Green
  },
];
const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(3);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer setup
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [currentIndex, visibleSlides]);

  // Adjust number of visible slides based on screen size
  useEffect(() => {
    const updateVisibleSlides = () => {
      if (window.innerWidth < 768) {
        setVisibleSlides(1); // Mobile: Show 1 card
      } else if (window.innerWidth < 1024) {
        setVisibleSlides(2); // Tablet: Show 2 cards
      } else {
        setVisibleSlides(3); // Desktop: Show 3 cards
      }
    };

    updateVisibleSlides();
    window.addEventListener("resize", updateVisibleSlides);
    return () => window.removeEventListener("resize", updateVisibleSlides);
  }, []);

  const totalSlides = slides.length;

  // Swipe handlers
  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }

    setTouchEnd(null);
    setTouchStart(null);
  };

  // Go to next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + visibleSlides >= totalSlides ? 0 : prevIndex + visibleSlides
    );
  };

  // Go to previous slide
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? totalSlides - visibleSlides : prevIndex - visibleSlides
    );
  };

  return (
    <section className="testimonial-section">
      <div className="testimonial-header">
        <p>Testimonials</p>
        <br />
        <div className="divider"></div>
      </div>

      <div className="testimonial-slider-wrapper">
        <button className="slider-btn left" onClick={prevSlide}>
          <ChevronLeft size={32} />
        </button>

        <div 
          className="testimonial-slider"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <AnimatePresence mode="wait">
            {slides
              .slice(currentIndex, currentIndex + visibleSlides)
              .map((testimonial) => (
                <motion.div
                  key={testimonial.id}
                  className="testimonial-card"
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -100 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={testimonial.img} alt={testimonial.author} />
                  <p className="testimonial-text">{testimonial.text}</p>
                  <h4 className="testimonial-author">{testimonial.author}</h4>
                  <p className="testimonial-position">{testimonial.position}</p>
                </motion.div>
              ))}
          </AnimatePresence>
        </div>

        <button className="slider-btn right" onClick={nextSlide}>
          <ChevronRight size={32} />
        </button>
      </div>

      <div className="dots-container">
        {Array.from({ length: Math.ceil(totalSlides / visibleSlides) }).map(
          (_, index) => (
            <div
              key={index}
              className={`dot ${Math.floor(currentIndex / visibleSlides) === index ? "active" : ""}`}
              onClick={() => setCurrentIndex(index * visibleSlides)}
            ></div>
          )
        )}
      </div>
    </section>
  );
};

const articles = [
  {
    id: 1,
    category: "DevOps & CI/CD",
    image: "images/image (7).jpg",
    title: "Revolutionizing CI/CD for Azure Logic Apps",
    description: "Following the successful migration from MuleSoft...",
  },
  {
    id: 2,
    category: "Retail & E-commerce",
    image: "images/AdobeStock_72421384.jpeg",
    title: "Seamless Migration to D365",
  },
  {
    id: 3,
    category: "Integration & Automation",
    image: "images/iway.png",
    title: "Enterprise-Scale Integration Transformation",
  },
  {
    id: 4,
    category: "Retail & E-commerce",
    image: "images/AdobeStock_1158752939.jpeg",
    title: "Driving Digital Transformation: Integrating Segment CDP ",
  },
  {
    id: 5,
    category: "Retail & E-commerce",
    image: "images/AdobeStock_459666237.jpeg",
    title: "Modernizing EDI Integration with MuleSoft",
  },
  {
    id: 6,
    category: "Integration & Automation",
    image: "images/people-working-lightbulb-color-year-2023.jpg",
    title: "Enhancing Eligibility Verification with Dell Boomi",
  },
  {
    id: 7,
    category: "Integration & Automation",
    image: "images/high-angle-boxes-laptop-arrangement.jpg",
    title: "Seamless Order Management with Boomi",
  },
  {
    id: 8,
    category: "Integration & Automation",
    image: "images/freepik__enhance__67791.png",
    title: "SAP to Epicor Integration Using Azure Logic Apps",
  },
];

const ArticlesSection = () => {
  const navigate = useNavigate();
  const getPath = (id) => {
    switch (id) {
      case 1:
        return "/blogs/Revolutionizing-CI/CD-for-Azure-Logic-Apps";
      case 2:
        return "/blogs/Seamless-migration-d365";
      case 3:
        return "/blogs/Transformation-From-iWay-to-mulesoft";
      case 4:
        return "/blogs/segment-cdp-data-marketing";
      case 5:
        return "/blogs/ecommerce-marketing-2025";
      case 6:
        return "/blogs/top-10-best-reads";
      case 7:
        return "/blogs/Integrating-QAD-and-EAM";
      case 8:
        return "/blogs/SAP-to-Epicor";
      default:
        return "/";
    }
  };
  const [startIndex, setStartIndex] = useState(0);
  const articlesPerPage = 6;

  const nextSlide = () => {
    setStartIndex((prev) => (prev + 3) % articles.length);
  };

  const prevSlide = () => {
    setStartIndex((prev) => (prev - 3 + articles.length) % articles.length);
  };

  return (
    <section className="articles-section px-8 py-12">
      <div className="w-full px-8">
        <p className="what-we-do-title">Our</p>
        <h2 className="text-4xl font-bold text-[#042e50] ml-6">
          Success Stories
        </h2>

        <div class="divider"></div>
        <div className="border-b border-gray-300 mt-2 w-full"></div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        {articles
          .slice(startIndex, startIndex + articlesPerPage)
          .map((article) => (
            <motion.div
              key={article.id}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              onClick={() => navigate(getPath(article.id))}
            >
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <span className="text-sm bg-gray-100 px-2 py-1 rounded-md">
                  {article.category}
                </span>
                <h3 className="text-lg font-semibold mt-2">{article.title}</h3>
              </div>
            </motion.div>
          ))}
      </div>
      <div className="flex justify-center mt-4">
        <button
          onClick={prevSlide}
          className="px-4 py-2 bg-gray-300 rounded-md mr-2"
        >
          <ChevronLeft size={32} />
        </button>
        <button
          onClick={nextSlide}
          className="px-4 py-2 bg-gray-300 rounded-md"
        >
          <ChevronRight size={32} />
        </button>
      </div>
    </section>
  );
};

// Define testimonials using slides array
const testimonials = slides;

// Email data handling
const sendEmailToDatabase = async (emailData) => {
  try {
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailData.email)) {
      throw new Error("Invalid email format");
    }

    const response = await fetch(
      "https://cvent.cyntra.ai/api/event/save-email",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: emailData.email,
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error(
        `Failed to save email: ${errorData.message || response.statusText}`
      );
      return false;
    }

    // Only log to console, don't show user notifications
    console.log("Email saved successfully!");
    return true;
  } catch (error) {
    console.error("Error saving email:", error.message);
    return false;
  }
};

const menuItems = {
  "What We Offer": [
    { name: "Integration Solutions", path: "/Migrating-ERPSolutions" },
    { name: "Enterprise Integration Solutions", path: "/ERP-Solutions" },
    {
      name: "Cloud-Native Excellence: CI/CD, DevOps & Automation",
      path: "/Devops-Services",
    },
    { name: "Application Management & Support", path: "/AMS-Services" },
    { name: "ERP Consulting & End-to-End Solutions", path: "/ERP-Consulting" },
  ],
  Knowledge: [
    { name: "Success Stories", path: "/blogs" },
    { name: "White Papers", path: "/White-Papers" },
  ],
  "Our Partners": [
    { name: "Service Now", path: "/Service-Now" },
    { name: "Google Cloud", path: "/Google-Cloud" },
    { name: "Salesforce", path: "/Salesforce" },
    { name: "SAP Labs", path: "/SAP-Labs" },
  ],
  About: [
    { name: "About Us", path: "/AboutUs" },
    { name: "Careers", path: () => window.open("https://cyntra.ai/careers") },
  ],
  Contact: [{ name: "Contact Us", path: "/Get-In-Touch" }],
};

const Homepage = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = window.innerWidth <= 768;
  const location = useLocation();

  // Extract and save email from URL if present - silently
  useEffect(() => {
    const extractAndSaveEmail = async () => {
      const searchParams = new URLSearchParams(location.search);
      const email = searchParams.get("email");

      if (email) {
        const success = await sendEmailToDatabase({ email });
        // Remove the email parameter from URL regardless of success
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      }
    };

    extractAndSaveEmail();
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 440) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // ✅ Dynamically load CSS based on screen size
  useEffect(() => {
    if (isMobile) {
      import("./HomepageMobile.css");
      document.body.style.overflowX = "hidden";
    } else {
      import("./Homepage.css");
      document.body.style.overflowX = "none";
    }
  }, [isMobile]);

  const handleToggleMenu = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const handleMouseEnter = (menu) => {
    setOpenDropdown(menu);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  // Define the paths based on service ID
  const servicePaths = {
    1: "/Migrating-ERPSolutions",
    2: "/ERP-Solutions",
    3: "/Devops-Services",
    4: "/AMS-Services",
  };

  const handleNavigation = (id) => {
    if (servicePaths[id]) {
      navigate(servicePaths[id]);
      window.scrollTo(0, 0); // Scrolls to the top after navigation
    } else {
      alert("Invalid Service ID");
    }
  };

  //Testimonials slider
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        return nextIndex < slides.length ? nextIndex : 0;
      });
    }, 9000); // Change slide every 4 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="homepage">
      <Header />

      {/* Mobile Drawer */}
      <SwipeableDrawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <div className="mobile-nav">
          {Object.entries(menuItems).map(([menu, links]) => (
            <div key={menu}>
              <button
                onClick={() => handleToggleMenu(menu)}
                className="mobile-nav-button"
              >
                {menu}
                <span
                  className={`dropdown-icon ${openDropdown === menu ? "rotate" : ""}`}
                >
                  <KeyboardArrowDownIcon />
                </span>
              </button>
              {openDropdown === menu && (
                <div className="mobile-dropdown">
                  <ul>
                    {links.map((item, index) => (
                      <li key={index}>
                        <Link
                          to={item.path}
                          className="dropdown-button"
                          onClick={() => {
                            setOpenDropdown(null);
                            setDrawerOpen(false);
                          }}
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </SwipeableDrawer>

      <main className="main-content">
        {/* Landing Section */}
        <motion.section
          className="landing-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <svg 
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 0,
              opacity: 0.9,
              overflow: 'visible'
            }}
            viewBox="0 0 1000 800"
            preserveAspectRatio="xMidYMid slice"
          >
            <g>
              {/* Primary layer - thicker lines */}
              {[...Array(10)].map((_, i) => (
                <motion.path
                  key={i}
                  stroke="#0064CD"
                  strokeWidth="1.2"
                  fill="none"
                  initial={{
                    d: `M${-50} ${Math.random() * 800} C ${100 + Math.random() * 200} ${Math.random() * 800}, ${400 + Math.random() * 300} ${Math.random() * 800}, ${1000 + 50} ${Math.random() * 800}`,
                    pathLength: 0,
                    opacity: 0
                  }}
                  animate={{
                    pathLength: [0, 1],
                    opacity: [0.15, 0.3],
                    d: `M${-50} ${Math.random() * 800} C ${100 + Math.random() * 200} ${Math.random() * 800}, ${400 + Math.random() * 300} ${Math.random() * 800}, ${1000 + 50} ${Math.random() * 800}`
                  }}
                  transition={{
                    duration: 12 + Math.random() * 8,
                    ease: "linear",
                    repeat: Infinity,
                    repeatType: "loop"
                  }}
                />
              ))}
              {/* Secondary layer - medium lines */}
              {[...Array(10)].map((_, i) => (
                <motion.path
                  key={`medium-${i}`}
                  stroke="#0064CD"
                  strokeWidth="1"
                  fill="none"
                  initial={{
                    d: `M${-50} ${Math.random() * 800} C ${200 + Math.random() * 400} ${Math.random() * 800}, ${500 + Math.random() * 200} ${Math.random() * 800}, ${1000 + 50} ${Math.random() * 800}`,
                    pathLength: 0,
                    opacity: 0
                  }}
                  animate={{
                    pathLength: [0, 1],
                    opacity: [0.1, 0.25],
                    d: `M${-50} ${Math.random() * 800} C ${200 + Math.random() * 400} ${Math.random() * 800}, ${500 + Math.random() * 200} ${Math.random() * 800}, ${1000 + 50} ${Math.random() * 800}`
                  }}
                  transition={{
                    duration: 15 + Math.random() * 10,
                    ease: "linear",
                    repeat: Infinity,
                    repeatType: "loop"
                  }}
                />
              ))}
              {/* Fine detail layer - thinnest lines */}
              {[...Array(5)].map((_, i) => (
                <motion.path
                  key={`fine-${i}`}
                  stroke="#0064CD"
                  strokeWidth="1"
                  fill="none"
                  initial={{
                    d: `M${-50} ${Math.random() * 800} C ${300 + Math.random() * 300} ${Math.random() * 800}, ${600 + Math.random() * 200} ${Math.random() * 800}, ${1000 + 50} ${Math.random() * 800}`,
                    pathLength: 0,
                    opacity: 0
                  }}
                  animate={{
                    pathLength: [0, 1],
                    opacity: [0.08, 0.2],
                    d: `M${-50} ${Math.random() * 800} C ${300 + Math.random() * 300} ${Math.random() * 800}, ${600 + Math.random() * 200} ${Math.random() * 800}, ${1000 + 50} ${Math.random() * 800}`
                  }}
                  transition={{
                    duration: 18 + Math.random() * 12,
                    ease: "linear",
                    repeat: Infinity,
                    repeatType: "loop"
                  }}
                />
              ))}
            </g>
          </svg>

          <motion.div
            className="landing-content"
            initial={{ y: 50 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{ position: 'relative', zIndex: 1 }}
          >
            <div className="landing-text">
              <div className="main-heading">
                <span className="text-gray">Intelligent Integrations </span>{" "} with
                <br />Limitless Possibilities
                <div className="elevated-text">
                -  Elevated by <span className="tripple-word">Agentic-AI</span>
                </div>
              </div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                className="cta-button-container"
              >
                <Link 
                  to="/blogs" 
                  className="cta-button"
                >
                  See Agentic AI in Action
                  <motion.span
                    animate={{ x: [0, 5, 0] }}
                    transition={{ duration: 1, repeat: Infinity }}
                  >
                    →
                  </motion.span>
                </Link>
              </motion.div>
            </div>
            
            <motion.div 
              className="landing-image"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative'
              }}
            >
              <img 
                src={landingImage} 
                className="landing-image-style"
                alt="Integration Diagram" 
              />
            </motion.div>
          </motion.div>
        </motion.section>

        {/* Industries Section */}
        <IndustriesSection />

        {/* Services Section */}
        <div className="services-header">
          <p className="what-we-do-title">Our</p>
          <h2 className="services-title">Services</h2>
          <div className="divider" style={{ width: "90%" }}></div>
        </div>

        <div className="services-container">
          {servicesData.map((service, index) => (
            <motion.div
              key={service.id}
              className="service-item"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: index * 0.1,
                ease: "easeOut",
              }}
              viewport={{ once: true }}
            >
              {/* Service Header Row: Number + Title */}
              <div className="service-header-row">
                <div className="service-content">
                  <h3 style={{ color: service.color }}>{service.title}</h3>
                </div>
                <div
                  className="service-number"
                  style={{ color: service.color }}
                >
                  {service.number}
                </div>
              </div>

              {/* Service Description and Button Row */}
              <div className="service-content">
                <p>{service.description}</p>
                <button
                  className="button-custom"
                  onClick={() => navigate(servicePaths[service.id] || "/")}
                >
                  Explore our offerings
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="animated-arrow"
                  >
                    <path
                      d="M1 1L14 14M15 3V13.5858C15 14.3668 14.3668 15 13.5858 15H3"
                      stroke="#010f1a"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </motion.div>
          ))}
        </div>

        <ArticlesSection />
        <TestimonialSection />
      </main>

      <Footer />
    </div>
  );
};

export default Homepage;
